import { translate as t } from '@thoughtspot/i18n';
export var TranslationKeys;
(function (TranslationKeys) {
    TranslationKeys["HELP_CUSTOMIZATION_TITLE"] = "help_customization.title";
    TranslationKeys["HELP_CUSTOMIZATION_SUBTITLE"] = "help_customization.subtitle";
    TranslationKeys["HELP_CUSTOMIZATION_ADD_MENUITEM"] = "help_customization.add.menuItem";
    TranslationKeys["HELP_CUSTOMIZATION_MENUITEMLABEL"] = "help_customization.mapping.menuItemLabel";
    TranslationKeys["HELP_CUSTOMIZATION_CUSTOMICON"] = "help_customization.mapping.customIcon";
    TranslationKeys["HELP_CUSTOMIZATION_ITEMURL"] = "help_customization.mapping.itemURl";
    TranslationKeys["HELP_CUSTOMIZATION_STATUS"] = "help_customization.mapping.status";
    TranslationKeys["HELP_CUSTOMIZATION_EDIT"] = "help_customization.mapping.edit";
    TranslationKeys["HELP_CUSTOMIZATION_UPLOAD"] = "help_customization.mapping.upload";
    TranslationKeys["HELP_CUSTOMIZATION_RESETTODEFAULT_CAPTION"] = "help_customization.resetToDefault.button.caption";
    TranslationKeys["HELP_CUSTOMIZATION_RESETTODEFAULT"] = "charts.chartEditor.RESET_COLORS";
    TranslationKeys["HELP_CUSTOMIZATION_RESETTODEFAULT_MODAL_TITLE"] = "help_customization.resetToDefault.modal.title";
    TranslationKeys["HELP_CUSTOMIZATION_RESETTODEFAULT_MODAL_CONTENT"] = "help_customization.resetToDefault.modal.content";
    TranslationKeys["HELP_CUSTOMIZATION_DELETEITEM_MODAL_TITLE"] = "help_customization.deleteItem.modal.title";
    TranslationKeys["HELP_CUSTOMIZATION_DELETEITEM_MODAL_CONTENT"] = "help_customization.deleteItem.modal.content";
    TranslationKeys["HELP_CUSTOMIZATION_VALIDATION_MENUITEM"] = "help_customization.validation.menuItemLabel";
    TranslationKeys["HELP_CUSTOMIZATION_VALIDATION_ITEMURL"] = "help_customization.validation.itemURL";
    TranslationKeys["HELP_CUSTOMIZATION_VALIDATION_CUSTOMICON"] = "help_customization.validation.customICon";
    TranslationKeys["HELP_CUSTOMIZATION_CUSTOMICON_FILE_SIZE"] = "help_customization.customIcon.file.size";
    TranslationKeys["HELP_CUSTOMIZATION_CANCELPROGRESS_MODAL_TITLE"] = "help_customization.cancelProgress.modal.title";
    TranslationKeys["HELP_CUSTOMIZATION_CANCELPROGRESS_MODAL_CONTENT"] = "help_customization.cancelProgress.modal.content";
    TranslationKeys["HELP_CUSTOMIZATION_LEARNMORE"] = "help_customization.learnMore";
    TranslationKeys["HELP_CUSTOMIZATION_VALIDATION_MESSAGE_MENUITEM"] = "help_customization.validation.message.menuItemLabel";
    TranslationKeys["HELP_CUSTOMIZATION_VALIDATION_MESSAGE_ITEMURL"] = "help_customization.validation.message.itemURL";
    TranslationKeys["HELP_CUSTOMIZATION_ALLOWED_EXTENSIONS"] = "help_customization.allowedExtension";
    TranslationKeys["HELP_CUSTOMIZATION_CANCEL_BUTTON_CAPTION"] = "help_customization.cancel.button.caption";
    TranslationKeys["HELP_CUSTOMIZATION_RESET_SUCCESS"] = "help_customization.resetToDefault.success";
    TranslationKeys["HELP_CUSTOMIZATION_DELETE_SUCCESS"] = "help_customization.deleteItem.success";
    TranslationKeys["HELP_CUSTOMIZATION_ADD_EDIT_SUCCESS"] = "help_customization.success.message";
    TranslationKeys["HELP_CUSTOMIZATION_SAVE_BUTTON"] = "Save";
    TranslationKeys["HELP_CUSTOMIZATION_CANCEL_BUTTON"] = "Cancel";
    TranslationKeys["HELP_CUSTOMIZATION_MENUITEM_PLACEHOLDER"] = "help_customization.menuitem.placeholder";
    TranslationKeys["HELP_CUSTOMIZATION_ITEMURL_PLACEHOLDER"] = "help_customization.itemURL.placeholder";
    TranslationKeys["HELP_CUSTOMIZATION_CUSTOMICON_PLACEHOLDER"] = "help_customization.customIcon.placeholder";
    TranslationKeys["HELP_CUSTOMIZATION_ERROR_MESSAGE"] = "help_customization.error.message";
    TranslationKeys["HELP_CUSTOMIZATION_DELETEITEM_BUTTON_CAPTION"] = "help_customization.deleteItem.button.caption";
    TranslationKeys["HELP_CUSTOMIZATION_ADDFORM_TITLE"] = "help_customization.form.add.title";
    TranslationKeys["HELP_CUSTOMIZATION_EDITFORM_TITLE"] = "help_customization.form.edit.title";
    TranslationKeys["HELP_CUSTOMIZATION_EDIT_BUTTON"] = "EDIT";
    TranslationKeys["HELP_CUSTOMIZATION_STATUS_ENABLE"] = "status.Enable";
    TranslationKeys["HELP_CUSTOMIZATION_STATUS_DISABLE"] = "status.Disable";
    TranslationKeys["HELP_CUSTOMIZATION_STATUS_ENABLED"] = "status.Enabled";
    TranslationKeys["HELP_CUSTOMIZATION_STATUS_DISABLED"] = "status.Disabled";
    TranslationKeys["HELP_CUSTOMIZATION_FILEUPLOAD_PLACEHOLDER"] = "security.ssl.fileInput.placeholder";
})(TranslationKeys || (TranslationKeys = {}));
export var DefaultIconMapping;
(function (DefaultIconMapping) {
    DefaultIconMapping["BLINK_HOW_SEARCH_WORKS"] = "video";
    DefaultIconMapping["BLINK_KEYWORDS"] = "key";
    DefaultIconMapping["BLINK_RELEASE_NOTES"] = "note";
    DefaultIconMapping["BLINK_DOCUMENTATION"] = "documentation";
    DefaultIconMapping["BLINK_DOWNLOADS"] = "download";
    DefaultIconMapping["BLINK_DEFAULT_ICON"] = "note";
    DefaultIconMapping["note"] = "note";
})(DefaultIconMapping || (DefaultIconMapping = {}));
export const MenuItemStatusMapping = () => [
    {
        true: t(TranslationKeys.HELP_CUSTOMIZATION_STATUS_ENABLED).toString(),
        false: t(TranslationKeys.HELP_CUSTOMIZATION_STATUS_DISABLED),
    },
];
export const NAME_REGEX = /^[a-zA-z\d\s]+$/g;
//# sourceMappingURL=constants.js.map